module.exports = __webpack_public_path__ + "img/4.6df6d786.png";